<template>
  <nav class="navbar" role="navigation">
    <div class="container is-fluid">
      <div class="navbar-brand">
        <router-link :to="{ name: 'home' }" class="navbar-item">
          <strong>Fit!</strong>
        </router-link>

        <a role="button" class="navbar-burger burger" data-target="navbarBasicExample">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-start" v-if="authUser && authUser.isAdmin">
          <router-link :to="{ name: 'applications' }" class="navbar-item">
            Applications
          </router-link>
          <router-link :to="{ name: 'trainers' }" class="navbar-item">
            Trainers
          </router-link>
          <router-link :to="{ name: 'users' }" class="navbar-item">
            Users
          </router-link>
        </div>
        <div class="navbar-end">
          <router-link :to="{ name: 'login' }" class="navbar-item" v-if="!authUser">
            Login
          </router-link>
          <a @click="handleLogout()" class="navbar-item" v-else>
            Logout
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { authUserQuery } from '../graphql/auth'

export default {
  apollo: {
    authUser: {
      query: authUserQuery,
      fetchPolicy: 'network-only'
    }
  },
  methods: {
    async handleLogout () {
      // logout
      await this.$cognito.logout()
      // redirect
      this.$router.replace({ name: 'login' })
    }
  },
  created () {
    // listen for auth changes and re-fetch the user
    this.$cognito.onAuth(() => {
      if (this.$apollo.queries.authUser) {
        this.$apollo.queries.authUser.refetch()
      }
    })
  }
}
</script>
